import React, { useMemo } from "react";
import { makeStyles, Theme } from "@material-ui/core";
import { Column } from "react-table";
import FooterTable from "./FooterTable";
import { BundlePart } from "../contexts/PartsterContext";
import { useVi } from "../contexts/ViContext";
import { getPartsToReplace } from "../services";

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      maxHeight: "100%",
      overflow: "scroll",
    },
  },
  // arrow: { margin: "0 0.618rem", justifySelf: "center", alignSelf: "center" },
  // caption: {
  //   marginBottom: "1rem",
  //   fontSize: "1rem",
  //   color: theme.palette.text.secondary,
  //   "&:last-of-type": { gridColumn: "3" },
  // },
}));

function BundlePartsFooter({
  bundleParts,
  className,
}: {
  bundleParts?: BundlePart[];
  className?: string;
}) {
  const classes = useStyles();
  const { claimDamagedParts } = useVi();

  const bundlePartsTableData = useMemo(() => bundleParts, [bundleParts]);

  const partsToReplaceTableData = useMemo(() => getPartsToReplace(claimDamagedParts), [
    claimDamagedParts,
  ]);

  const bundlePartsColumns: Column[] = [
    {
      accessor: "label",
      Header: "Part",
      Cell: ({ cell }: { cell: any }) =>
        (cell.value as string).replace(
          /(?:\b\w+\b)|(?:\W+)/g,
          (match) => match[0].toUpperCase() + match.slice(1).toLowerCase()
        ),
    },
    {
      accessor: "id",
      Header: "Standard Guide Number",
    },
    {
      accessor: "score",
      Header: "Confidence",
      Cell: ({ cell }: any) => `${Math.max(Math.round(cell.value * 100), 1)}%`,
      sortType: (a: any, b: any) => {
        return a.values.score - b.values.score;
      },
    },
  ];

  const partsToReplaceColumns: Column[] = [
    {
      accessor: "genericPartName",
      Header: "Part",
      Cell: ({ cell }: { cell: any }) =>
        (cell.value as string).replace(
          /(?:\b\w+\b)|(?:\W+)/g,
          (match) => match[0].toUpperCase() + match.slice(1).toLowerCase()
        ),
    },
    {
      accessor: "standardGuideNumber",
      Header: "Standard Guide Number",
    },
  ];

  return (
    <div className={[className, classes.wrapper].join(" ")}>
      {/* <Typography className={classes.caption} variant="caption">
        {"Bundle Parts suggested for replacement"}
      </Typography>
      <Typography className={classes.caption} variant="caption">
        {"Parts predicted to require replacement"}
      </Typography> */}
      <FooterTable
        {...{
          data: bundlePartsTableData,
          columns: bundlePartsColumns,
          initialState: { sortBy: [{ id: "score", desc: true }] },
        }}
      />
      {/* <ArrowBackIosIcon className={classes.arrow} />
      <FooterTable
        {...{
          data: partsToReplaceTableData,
          columns: partsToReplaceColumns,
          initialState: { sortBy: [{ id: "genericPartName" }] },
        }}
      /> */}
    </div>
  );
}

export default React.memo(BundlePartsFooter);
